import React from 'react';
import Link from 'react-router';
import Moment from 'react-moment';
import { Meteor } from 'meteor/meteor';

import {
  Button
} from '@sketchpixy/rubix';

export default class OptionListComponent extends React.Component {

  	render() {
  	  	return (
  	  	  	<tr>
              <td>{this.props.option.title}</td>
              <td>{this.props.option.price}€</td>
              <td><Moment format="DD/MM/YYYY">{this.props.option.createdAt}</Moment></td>
              <td><Moment format="DD/MM/YYYY">{this.props.option.editedAt}</Moment></td>
              <td>
                  <Button bsStyle="warning" onClick={this.goToEditView.bind(this)}>Modifier</Button>&nbsp;&nbsp;
                  <Button bsStyle="danger" onClick={this.deleteThisPrice.bind(this)}>Supprimer</Button>
              </td>
            </tr>
  	  	);
  	}

    deleteThisPrice() {
      Meteor.call('options.remove', this.props.option._id);
    }

    goToEditView() {
     this.context.router.push('/options/' + this.props.option._id);
    }

}

OptionListComponent.propTypes = {
  // This component gets the task to display through a React prop.
  // We can use propTypes to indicate it is required
  option: React.PropTypes.object.isRequired,
};

OptionListComponent.contextTypes = {
  router: React.PropTypes.object.isRequired
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/options/component-options-list.js
 **/